import { useParams } from 'react-router-dom';

import { ChronologiesTable } from './components/chronologies-table';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { useGetSubset } from '@/api/queries/useGetSubset';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';
import { SubsetChip } from '@/new/components/subset-chip';
import { useSubsetBreadcrumbs } from '@/new/hooks/use-subset-breadcrumbs';

export function Chronologies() {
  const { matterId, subsetId } = useParams();
  if (!matterId || !subsetId) return null;

  const { data: matter } = useGetMatterV2(matterId);
  const { data: subset } = useGetSubset(matterId, subsetId);

  const breadcrumbItems = useSubsetBreadcrumbs({
    matterId,
    subsetId,
    matter,
    subset,
    currentPage: { label: 'Chronologies', path: 'chronologies' },
  });

  return (
    <>
      <Breadcrumb items={breadcrumbItems} />

      <PageContainer>
        <PageHeader>
          <div className="flex items-center gap-4">
            <PageTitle text="Chronologies" />
            <SubsetChip subsetId={subsetId} className="mt-0.5" />
          </div>
        </PageHeader>
      </PageContainer>

      <ChronologiesTable />
    </>
  );
}
